const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5004/v1/api';
const UPLOAD_BASE_URL =
  process.env.REACT_APP_UPLOAD_BASE_URL ||
  API_BASE_URL.replace(/\/v1\/api\/?$/, '');

const appConfig = {
  apiBaseUrl: API_BASE_URL,
  uploadBaseUrl: UPLOAD_BASE_URL,
  uploadUrl: (path) => `${UPLOAD_BASE_URL}/uploads/${path}`,
  site: {
    title: process.env.REACT_APP_SITE_TITLE || 'Hiwa Boutique Hotel',
    description: process.env.REACT_APP_SITE_DESCRIPTION || '',
  },
  hotel: {
    name: process.env.REACT_APP_HOTEL_NAME || 'Hiwa Boutique Hotel',
    legalName: process.env.REACT_APP_HOTEL_LEGAL_NAME || 'HIWA BOUTIQUE HOTEL',
    shortName: process.env.REACT_APP_HOTEL_SHORT_NAME || 'Hiwa',
    tagline: process.env.REACT_APP_HOTEL_TAGLINE || 'Elite Hotel By Hiwa',
    address: process.env.REACT_APP_HOTEL_ADDRESS || 'Om Vihar Colony, Medipally, Canara Nagar, Boduppal, Hyderabad, Telangana 500098',
    locationUrl:
      process.env.REACT_APP_HOTEL_LOCATION_URL ||
      process.env.REACT_APP_GOOGLE_MAPS_URL ||
      'https://www.google.com/maps/place/Hiwa+Boutique+Hotel/@17.40752,78.598689,17z',
    phone: process.env.REACT_APP_HOTEL_PHONE || '+91 9121987321',
    invoicePhone: process.env.REACT_APP_HOTEL_INVOICE_PHONE || process.env.REACT_APP_HOTEL_PHONE || '+91 9121987321',
    email: process.env.REACT_APP_HOTEL_EMAIL || 'info.hiwahotels@gmail.com',
    copyrightLocation: process.env.REACT_APP_HOTEL_COPYRIGHT_LOCATION || 'Boduppal, Hyderabad',
    paymentName: process.env.REACT_APP_HOTEL_PAYMENT_NAME || 'HIWA BOUTIQUE HOTEL',
    aboutTitle: process.env.REACT_APP_HOTEL_ABOUT_TITLE || 'About Hiwa Boutique Hotel',
    aboutTagline: process.env.REACT_APP_HOTEL_ABOUT_TAGLINE || 'Your Elegant Boutique Retreat in Hyderabad',
    roomSummary:
      process.env.REACT_APP_HOTEL_ROOM_SUMMARY ||
      '32 beautifully appointed rooms, including 12 Hiwa Comfort, 12 Hiwa Superior, and 8 Hiwa Suites',
    locationLabel: process.env.REACT_APP_HOTEL_LOCATION_LABEL || 'Boduppal, Hyderabad',
    nearbyLandmark: process.env.REACT_APP_HOTEL_NEARBY_LANDMARK || 'Medipally',
    city: process.env.REACT_APP_HOTEL_CITY || 'Hyderabad',
  },
  pincodeApiUrl: process.env.REACT_APP_PINCODE_API_URL || 'https://api.postalpincode.in/pincode',
  bookingsPageSize: parseInt(process.env.REACT_APP_BOOKINGS_PAGE_SIZE, 10) || 10,
};

export default appConfig;
export { API_BASE_URL, UPLOAD_BASE_URL };
